export default {
  container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
  taskProfiles: {
    flex: 1,
  },
  taskProfileItems: {
    flex: 1,
  },
  avatar: {
    backgroundColor: 'red',
  },
  itemsList: {
    height: 300,
    overflowY: 'scroll',
  },
};



// WEBPACK FOOTER //
// ./src/components/TaskProfileDrilldown/styles.js